<template>
  <div class="border rounded mb-1 p-1 d-flex" style="width: 100%;">
    <div class="w-85">
      <!-- REPLACED HEADING WITH PARAGRAPH -->
      <!-- <h5 class="text-center text-uppercase">
        <strong>{{ headingContent }}</strong>
      </h5> -->
      <p
        class="text-center text-uppercase pt-1"
        style="color: black; font-size: 18.5px;"
      >
        <strong>{{ headingContent }}[{{ formattedDate(note_date) }}]</strong>
      </p>
      <!-- REPLACED HEADING WITH PARAGRAPH -->

      <!-- REPLACED TEXT AREA WITH DIV -->
      <!-- <textarea
        readonly="readonly"
        class="form-control"
        rows="15"
        v-model="textAreaContent"
      >
      </textarea> -->
      <div
        v-html="textAreaContent"
        class="border rounded form-control text-area"
      ></div>
      <!-- REPLACED TEXT AREA WITH DIV -->
    </div>
    <div class="w-15" style="position: relative;">
      <button @click="openNote" class="btn btn-primary center">
        Append Notes
      </button>
    </div>
  </div>
</template>

<script>
import { formattedDate } from "@/utilities/date.js";

export default {
  name: "Note",
  props: ["headingContent", "textAreaContent", "note_id", "note_date"],
  methods: {
    openNote() {
      this.$store.state.orderDetails.openNote_Loading = true;
      this.$router
        .push({
          name: "NotesManager",
          query: {
            order_id: this.$route.query.order_id,
            note_id: this.note_id,
          },
        })
        .then(() => {
          this.$store.dispatch("orderDetails/getExtraOrderInfo", {
            orderId: this.$route.query.order_id,
          });
          this.$store
            .dispatch("orderDetails/getCRMNote", {
              noteId: Number(this.note_id),
            })
            .then(() => {
              this.$store.state.orderDetails.new_note = false;
            })
            .finally(() => {
              window.scrollTo(0, 0);
              this.$store.state.orderDetails.openNote_Loading = false;
            });
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          window.scrollTo(0, 0);
          this.$store.state.orderDetails.openNote_Loading = false;
        });
    },
    formattedDate,
  },
};
</script>

<style lang="scss" scoped>
.w-85 {
  width: 85%;
}
.w-15 {
  width: 15%;
}
.center {
  white-space: nowrap;
  position: absolute;
  right: 3px;
  top: 3px;
}
.text-area {
  height: 350px;
  overflow-x: hidden;
  resize: vertical;
  background-color: #eaf1f5;
}
</style>
